export const SET_USER_FIELD = 'SET_USER_FIELD'
export const SET_STATE_DIALOG = 'SET_STATE_DIALOG'
export const SET_REDIRECT_PATH = 'SET_REDIRECT_PATH'
